import { useContext, useEffect, useRef } from "react";
import { API_BASE_URL, APIs } from "../../../../constants/Constants";
import AgenticReportingContext from "../../../../context/agentic-reporting/AgenticReportingContext";

export default function FinalReportSubscriber({
  onReportReceived,
  isListening,
}) {
  const { llmSessionId } = useContext(AgenticReportingContext);

  const onReportReceivedRef = useRef(onReportReceived);

  useEffect(() => {
    onReportReceivedRef.current = onReportReceived;
  }, [onReportReceived]);

  useEffect(() => {
    if (!isListening || !llmSessionId) {
      return;
    }

    const url = API_BASE_URL + APIs.SSE_SUBSCRIBE + llmSessionId;
    console.log("FinalReportSubscriber: Opening SSE connection to:", url);

    const eventSource = new EventSource(url, { withCredentials: true });

    const handleFinalReport = (e) => {
      console.log("FinalReportSubscriber: Final report received.", e.data);
      try {
        const data = JSON.parse(e.data);
        if (data.status === "failure") {
          console.error("Webhook reported failure:", data.message);
        }
        if (onReportReceivedRef.current) {
          onReportReceivedRef.current(
            data.finalReport,
            data.voiceAssistantSummary,
            data.status,
            data.message,
          );
        }
      } catch (err) {
        console.error("Failed to parse final report data:", err);
        if (onReportReceivedRef.current) {
          onReportReceivedRef.current(e.data, null);
        }
      }
    };

    eventSource.addEventListener("finalReport", handleFinalReport);

    eventSource.onerror = (err) => {
      console.error("FinalReportSubscriber: SSE error occurred.", err);
      if (onReportReceivedRef.current) {
        onReportReceivedRef.current();
      }
      eventSource.close();
    };

    return () => {
      console.log("FinalReportSubscriber: Closing SSE connection.");
      eventSource.close();
    };
  }, [isListening, llmSessionId]);

  return null;
}
